/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mod6_LinkInputs */

const es_landing_mod6_link = /** @type {(inputs: Landing_Mod6_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver charter`)
};

const gl_landing_mod6_link = /** @type {(inputs: Landing_Mod6_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver charter`)
};

const en_landing_mod6_link = /** @type {(inputs: Landing_Mod6_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View charter`)
};

/**
* | output |
* | --- |
* | "View charter" |
*
* @param {Landing_Mod6_LinkInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_mod6_link = /** @type {((inputs?: Landing_Mod6_LinkInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mod6_LinkInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_mod6_link(inputs)
	if (locale === "en") return en_landing_mod6_link(inputs)
	return es_landing_mod6_link(inputs)
});